import { roleSteps } from "./Roles.tsx";
import { roleDetailsCreate } from "./Create.tsx";
import { roleEditSteps } from "./Edit.tsx";
/**
 * Dynamically return the appropriate Joyride steps based on the path and query params
 * @param {string} path - current URL pathname
 * @param {URLSearchParams} query - query object (new URLSearchParams(location.search))
 * @returns {Array} steps - Joyride steps
 */
export const getRolesJoyrideSteps = (path, query, activeTab) => {

  if (path === "/roles") {
    return roleSteps;
  }
  if (path === "/roles/roledetails") {
    const id = query.get("roleId");

    if (id && id !== "0") {
      return roleEditSteps;
    }
    return roleDetailsCreate;
  }
  return [];
};
